/**
 * Recruiter/HR B2B CTA tracking (story fx-3.1).
 *
 * Fires the `b2b_cta_click` event through the Epic 1 canonical analytics
 * service (src/services/analyticsService.ts) whenever a user engages the
 * persistent B2B soft CTA. The event is consent-managed and carries no PII —
 * only the non-identifying trigger source (AC fx-3.1#AC3).
 */

import { trackEvent } from './googleAnalytics';

export const B2B_CTA_EVENT_NAME = 'b2b_cta_click';
export const B2B_CTA_DEFAULT_SOURCE = 'b2b_cta_banner';

export function trackB2bCtaClick(source: string = B2B_CTA_DEFAULT_SOURCE): void {
  trackEvent({
    event_name: B2B_CTA_EVENT_NAME,
    event_category: 'b2b',
    event_label: source,
    custom_parameters: { cta_source: source },
  });
}
